import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter', pure: false })
export class FilterPipe implements PipeTransform {
  transform(arr: string[], searchValue: string | number) { 
    if (searchValue !== 0 && (!searchValue || !arr.length)) return false;

    return !!(arr.filter(element => element == searchValue).length); 
  }
}